export const shipmentDeliveryInfoValueProps = {
    qualityMattressOnly: {
        title: 'Quality from start to finish',
        content: [
            'After your mattress is handcrafted, it goes through a strict inspection process',
            `It’s then transferred to our local delivery partner`
        ]
    },
    qualityFurnitureOnly: {
        title: 'Quality from start to finish',
        content: [
            'All of our bedroom furniture and rugs are handcrafted and go through a strict inspection process.',
            `After you place your order, it's then transferred to our local delivery partner`
        ]
    },
    qualityCombined: {
        title: 'Quality from start to finish',
        content: [
            'All of our products go through a strict inspection process before they leave our factories',
            `Your mattress and furniture are transferred at the same time to our local delivery partner near you`
        ]
    },
    schedulingMattressOnly: {
        title: 'Easy scheduling',
        content: [
            `After receiving your product, our local delivery partner will contact you to schedule your delivery date`,
            `They'll provide you with a 4-hour delivery window the day before.<sup>*</sup>`,
            `If you need to cancel or reschedule your delivery, you won't be charged a fee`
        ],
        disclaimer: '<sup>*</sup>White glove delivery orders do not get a tracking number, instead, a local delivery partner near you will contact you directly to schedule your delivery.'
    },
    schedulingFurnitureOnly: {
        title: 'Easy scheduling',
        content: [
            `After receiving your product/s, our local delivery partner will contact you to schedule your delivery date`,
            `They'll provide you with a 4-hour delivery window the day before.<sup>*</sup>`,
            `If you need to cancel or reschedule your delivery, you won't be charged a fee`
        ],
        disclaimer: '<sup>*</sup>White glove delivery orders do not get a tracking number, instead, a local delivery partner near you will contact you directly to schedule your delivery.'
    },
    schedulingCombined: {
        title: 'Easy scheduling',
        content: [
            `After receiving your products, our local delivery partner will contact you to schedule your delivery date`,
            `They'll provide you with a 4-hour delivery window the day before.<sup>*</sup>`,
            `If you need to cancel or reschedule your delivery, you won't be charged a fee`
        ],
        disclaimer: '<sup>*</sup>White glove delivery orders do not get a tracking number, instead, a local delivery partner near you will contact you directly to schedule your delivery.'
    },
    mattressOnly: {
        title: 'A mattress made fresh to order',
        content: [
            `After your order is confirmed, it's crafted just for you in one of our U.S. factories.`
        ]
    },
    mattressCombined: {
        title: 'A mattress made fresh to order',
        content: [
            `After your order is confirmed, your mattress is crafted just for you in one of our U.S. factories `
        ]
    },
    deliveryMattressOnly: {
        title: 'Hassle-free delivery',
        content: [
            'Sit back, relax, and let our delivery crew do the heavy lifting as they hand-deliver your mattress in the room of your choice.'
        ]
    },
    deliveryFurnitureOnly: {
        title: 'Free in-room delivery & assembly',
        content: [
            'Sit back, relax, and let our delivery crew do the heavy lifting',
            `They'll hand-deliver and assemble your furniture (if applicable) and/or rug<sup>*</sup> in the room of your choice`
        ],
        disclaimer: '<sup>*</sup>Delivery team will not be responsible for moving furniture. Prior to delivery, they will ask that you clear the area where you want your rug placed.'
    },
    deliveryCombined: {
        title: 'Hassle-free delivery',
        content: [
            'Sit back, relax, and let our delivery crew do the heavy lifting',
            `They'll hand-deliver and set up your mattress`,
            `They'll also hand-deliver and assemble your furniture (if applicable) and/or rug<sup>*</sup> in the room of your choice`
        ],
        disclaimer: '<sup>*</sup>Delivery team will not be responsible for moving furniture. Prior to delivery, they will ask that you clear the area where you want your rug placed.'
    },
    direct: {
        title: 'Free ground shipping ',
        content: [
            `Once it arrives at the delivery carrier, you can expect your order to be delivered within 5-8 business days<sup>*</sup>`
        ],
        disclaimer: '<sup>*</sup>Actual shipping times may vary by location. Only within the continental U.S.'
    },
    qualityDirect: {
        title: 'Quality from start to finish',
        content: [
            'Your order passes through quality inspection and is ready to leave the warehouse within 2-3 business days',
        ]
    },
}

export const shipmentDeliveryInfoConfig = {
    whiteGlove: {
        mattressOnly: {
            title: 'What to expect with our FREE premium white glove delivery',
            subtitle: 'Made to order and delivered in 1-3 weeks',
            contentKeys: ['mattressOnly', 'qualityMattressOnly', 'schedulingMattressOnly', 'deliveryMattressOnly']
        },
        furnitureOnly: {
            title: 'What to expect with our FREE white glove delivery',
            subtitle: 'Hassle-free delivery in 3-4 weeks',
            contentKeys: ['qualityFurnitureOnly', 'schedulingFurnitureOnly', 'deliveryFurnitureOnly']
        },
        mattressAndFurniture: {
            title: 'What to expect with our FREE premium white glove delivery',
            subtitle: 'Hassle-free delivery in 3-4 weeks',
            contentKeys: ['mattressCombined', 'qualityCombined', 'schedulingCombined', 'deliveryCombined']
        }
    },
    direct: {
        fedex: {
            title: 'What to expect with our free ground shipping',
            subtitle: 'Ready to ship in 2-3 business days',
            contentKeys: ['qualityDirect', 'direct']
        }
    }
}